import React from 'react';

import { ReviewStatus } from '@ndvr/portfolio-api';

import { IconAlertTriangle, IconCheckmarkCircle, Tag } from 'widgets';

export const PortfolioReviewStatus = ({ reviewStatus }: { reviewStatus: ReviewStatus }) => {
    switch (reviewStatus) {
        case ReviewStatus.APPROVED:
            return (
                <Tag type="positive" icon={<IconCheckmarkCircle size="micro" />}>
                    Approved
                </Tag>
            );
        case ReviewStatus.READY_FOR_REVIEW:
            return (
                <Tag type="negative" icon={<IconAlertTriangle size="micro" />}>
                    Needs Approval
                </Tag>
            );
        case ReviewStatus.WORK_IN_PROGRESS:
            return <Tag type="info">In Progress</Tag>;
        default:
            return null;
    }
};
